import { ElementRef } from '@angular/core';

function createCoercionDecoratorFactory(coerce) {
    return () => (target, name) => {
        const key = Symbol.for(`coercion.${String(name)}`);
        Object.defineProperty(target, name, {
            get() {
                return this[key];
            },
            set(value) {
                this[key] = coerce(value);
            },
        });
    };
}

function coerceArray(value) {
    return Array.isArray(value) ? value : [value];
}
const CoerceArray = createCoercionDecoratorFactory(coerceArray);

function isObject(value) {
    return typeof value === 'object' && !Array.isArray(value) && value != null;
}
function coerceBoolean(value) {
    return value != null && `${value}` !== 'false';
}
function coerceBooleanVariant(candidate) {
    if (!isObject(candidate))
        return coerceBoolean(candidate);
    let isVariant = false;
    const variant = Object.entries(candidate).reduce((acc, [key, value]) => {
        if (!key.startsWith('@')) {
            acc[key] = value;
            return acc;
        }
        acc[key] = coerceBoolean(value);
        isVariant = true;
        return acc;
    }, {});
    return isVariant ? variant : coerceBoolean(candidate);
}
const CoerceBoolean = createCoercionDecoratorFactory(coerceBoolean);
const CoerceBooleanVariant = createCoercionDecoratorFactory(coerceBooleanVariant);

/**
 * Coerces the native element from an `ElementRef` if necessary.
 * @param value value to be coerced
 * @returns An element contianed inside a `ElementRef` or the provided value.
 */
function coerceElement(value) {
    return value instanceof ElementRef ? value.nativeElement : value;
}

/**
 * Generated bundle index. Do not edit.
 */

export { CoerceArray, CoerceBoolean, CoerceBooleanVariant, coerceArray, coerceBoolean, coerceBooleanVariant, coerceElement, createCoercionDecoratorFactory };
